<script>
    import ModalEdit from '../../../layouts/ModalEdit.vue';

    export default {
        components:{
        },
        extends: ModalEdit,
        name: 'modal',
        props: ['value'],
        data: function () {
            return {
                internalValue: '',
                currency: ''
            }
        },
        mounted: function(){

        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
            close() {
                this.$emit('close');
            },
            validate(){
                this.$emit('validate');
            },
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            }
        }
    };
</script>
<template>
    <transition name="modal-fade" v-if="internalValue">
        <div class="modal-backdrop">
            <div class="modal"
                 role="dialog"
                 aria-labelledby="modalTitle"
                 aria-describedby="modalDescription">
                <article>
                    <header class="modal-header"
                            id="modalTitle">
                        <figure><i class="icon" v-bind:class="{'icon-icon_email':internalValue.support == 'email','icon-icon_sms':internalValue.support == 'sms'}"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Campagne <i class="icon icon-icon_arrow-right"></i> Envoi
                            </span>
                            <h1>Envoi TEST</h1>
                        </div>
                        <div class="spacer"></div>
                        <div>
                            <button @click="close()" class="bt-back" title="Annuler"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="validate()" class="bt-primary bt-save" title="Valider"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <div>

                        <div class="form-field">
                            <div class="form-label">
                                <label>Audience</label>
                            </div>
                            <div class="form-input">
                                <div class="form-input-wrapper" style="border: 0;padding-top: 10px;">
                                    {{ $store.state.user.clientable.name }}
                                </div>
                            </div>
                        </div>

                        <form-phone :label="'Phone number'" v-model="internalValue.phone" v-if="internalValue.support == 'sms'"></form-phone>
                        <form-text :label="'Adresse Email'" v-model="internalValue.email" v-if="internalValue.support == 'email'"></form-text>

                        <div class="form-field">
                            <div class="form-label">
                                <label>Coûts estimés</label>
                            </div>
                            <div class="form-input" v-if="internalValue.support == 'sms'">
                                <div class="form-input-wrapper" style="border: 0;padding-top: 10px;">
                                    CHF 0.065
                                </div>
                            </div>
                            <div class="form-input" v-if="internalValue.support == 'email'">
                                <div class="form-input-wrapper" style="border: 0;padding-top: 10px;">
                                    Gratuit
                                </div>
                            </div>
                        </div>

                    </div>

                </article>
            </div>
        </div>
    </transition>
</template>


// WEBPACK FOOTER //
// src/modules/campaign/campaign/Modal.vue